






































import gql from 'graphql-tag'
import { Component, Mixins } from 'vue-property-decorator'

import AppFormCard from '@/components/AppFormCard.vue'
import AppTitleBar from '@/components/AppTitleBar.vue'
import ItemListItem from '@/components/ItemListItem.vue'
import { ASK_ORDER_ITEM } from '@/gql/order'
import { OrderMixin } from '@/mixins'

@Component({
  components: {
    AppFormCard,
    AppTitleBar,
    ItemListItem
  }
})
export default class extends Mixins(OrderMixin) {
  orderAskTypes = ['PRODUCT', 'DELIVERY', 'REFUND', 'RETURN', 'ETC']
  selectedAskType = ''
  askDetail = ''
  isPrivate = false

  get submitEnabled () {
    return this.selectedAskType && this.askDetail
  }

  async submit () {
    await this.showLoading()
    try {
      if (this.$route.query.orderItemId) {
        const { data } = await this.$apollo.mutate({
          mutation: ASK_ORDER_ITEM,
          variables: {
            input: {
              orderId: this.$route.query.orderId,
              orderItemId: this.$route.query.orderItemId,
              orderAskType: this.selectedAskType,
              orderAskDetail: this.askDetail,
              isPrivate: this.isPrivate
            }
          }
        })

        await this.showToast(data.askOrderItem.message)
      } else {
        const { data } = await this.$apollo.mutate({
          mutation: gql`mutation askItem($input: AskItemInput!) {
            askItem(input: $input) {
              message
            }
          }`,
          variables: {
            input: {
              itemId: this.$route.params.id,
              orderAskType: this.selectedAskType,
              orderAskDetail: this.askDetail,
              isPrivate: this.isPrivate
            }
          }
        })

        await this.showToast(data.askItem.message)
      }
      this.evictApolloCache(`orderAskConnectionV2({"filter":{"itemId":"${this.$route.params.id}"}})`)
      this.evictApolloCache(`orderAskCount({"filter":{"itemId":"${this.$route.params.id}"}})`)
      this.$router.back()
    } finally {
      await this.dismissLoading()
    }
  }
}
